import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';

const Reservation = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: 2,
    specialRequests: ''
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const timeSlots = [
    '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
    '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.email || !formData.phone || !formData.date || !formData.time) {
      setShowError(true);
      setShowSuccess(false);
      return;
    }

    // Simulate form submission
    console.log('Reservation submitted:', formData);
    
    // Show success message
    setShowSuccess(true);
    setShowError(false);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      date: '',
      time: '',
      guests: 2,
      specialRequests: ''
    });
  };

  const getMinDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  return (
    <div className="py-5">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold text-dark mb-3">მაგიდის დაჯავშნა</h1>
            <p className="lead text-muted">
              დაჯავშნა გააკეთეთ ახლავე და უზრუნველყავით თქვენი ადგილი ჩვენს რესტორანში
            </p>
          </Col>
        </Row>

        <Row>
          <Col lg={8} className="mb-4">
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <h3 className="text-warning mb-4">
                  <i className="fas fa-calendar-check me-2"></i>
                  დაჯავშნის ფორმა
                </h3>

                {showSuccess && (
                  <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                    <i className="fas fa-check-circle me-2"></i>
                    თქვენი დაჯავშნა წარმატებით გაიგზავნა! ჩვენ მალე დაგიკავშირდებით.
                  </Alert>
                )}

                {showError && (
                  <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    გთხოვთ შეავსოთ ყველა სავალდებულო ველი.
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-user me-2"></i>
                          სახელი და გვარი *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="შეიყვანეთ თქვენი სახელი"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-envelope me-2"></i>
                          ელ-ფოსტა *
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="შეიყვანეთ ელ-ფოსტა"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-phone me-2"></i>
                          ტელეფონი *
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+995 555 123 456"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-users me-2"></i>
                          სტუმრების რაოდენობა
                        </Form.Label>
                        <Form.Select
                          name="guests"
                          value={formData.guests}
                          onChange={handleInputChange}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                            <option key={num} value={num}>{num} ადამიანი</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-calendar me-2"></i>
                          თარიღი *
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          min={getMinDate()}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-clock me-2"></i>
                          დრო *
                        </Form.Label>
                        <Form.Select
                          name="time"
                          value={formData.time}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">აირჩიეთ დრო</option>
                          {timeSlots.map(time => (
                            <option key={time} value={time}>{time}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-bold">
                      <i className="fas fa-comment me-2"></i>
                      სპეციალური მოთხოვნები
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="specialRequests"
                      value={formData.specialRequests}
                      onChange={handleInputChange}
                      placeholder="მიუთითეთ სპეციალური მოთხოვნები (არასავალდებულო)"
                    />
                  </Form.Group>

                  <Button 
                    type="submit" 
                    variant="warning" 
                    size="lg" 
                    className="w-100 fw-bold"
                  >
                    <i className="fas fa-paper-plane me-2"></i>
                    დაჯავშნის გაგზავნა
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className="shadow-sm h-100">
              <Card.Body className="p-4">
                <h4 className="text-warning mb-4">
                  <i className="fas fa-info-circle me-2"></i>
                  მნიშვნელოვანი ინფორმაცია
                </h4>
                
                <div className="mb-4">
                  <h6 className="fw-bold">
                    <i className="fas fa-clock me-2 text-warning"></i>
                    სამუშაო საათები
                  </h6>
                  <p className="text-muted mb-2">ორშაბათი - პარასკევი: 11:00 - 23:00</p>
                  <p className="text-muted">შაბათი - კვირა: 12:00 - 00:00</p>
                </div>

                <div className="mb-4">
                  <h6 className="fw-bold">
                    <i className="fas fa-phone me-2 text-warning"></i>
                    დაჯავშნა ტელეფონით
                  </h6>
                  <p className="text-muted mb-2">+995 555 123 456</p>
                  <p className="text-muted">ყოველდღე 9:00 - 21:00</p>
                </div>

                <div className="mb-4">
                  <h6 className="fw-bold">
                    <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                    მნიშვნელოვანი
                  </h6>
                  <ul className="text-muted small">
                    <li>დაჯავშნა უნდა გაკეთდეს მინიმუმ 2 საათით ადრე</li>
                    <li>დიდი ჯგუფებისთვის (8+ ადამიანი) დაჯავშნა უნდა გაკეთდეს 24 საათით ადრე</li>
                    <li>შაბათობით ბუფე ხელმისაწვდომია 12:00-16:00</li>
                  </ul>
                </div>

                <div className="text-center">
                  <Button variant="outline-warning" className="w-100 fw-bold">
                    <i className="fas fa-download me-2"></i>
                    მენიუს ჩამოტვირთვა
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reservation;
